import { Injectable } from '@angular/core';
import { AnnouncementModel } from '../models/announcement-model';
import { AnnouncementsService } from '../services/announcements.service';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, take, mergeMap, of, EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsResolverService implements Resolve<AnnouncementModel[]> {

  constructor(private svc: AnnouncementsService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.svc.getTodayAnnouncements().pipe(take(1), mergeMap(e => {
      if (e) {
        return of(e);
      } else {
        return EMPTY;
      }
    }));
  }
}
